module.exports = __webpack_public_path__ + "static/media/jimmy-script-regular.1445c16e.woff2";